import { MediaSearchGallery } from "../components/search/MediaSearchGallery";
import type { ContentType } from "../api/types";

/** Module-level so the array identity stays stable across renders. */
const VIDEOS: ContentType[] = ["VIDEO"];

/**
 * Videos gallery. Same searchable, tag-filterable, sortable, paginated contact
 * sheet as photos, with a play glyph on each frame; selecting one opens its
 * document page, which plays the video and hosts its comment thread.
 *
 * Like Photos, it runs at `scope="MAIN"` — dive clips are browsed in the Scuba
 * section rather than mixed in here, and the gallery links straight to it.
 */
export function VideosPage() {
  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Collection 02 · Videos</p>
          <h1 className="page__title">Videos</h1>
          <p className="page__intro">
            Drone flights, travel edits, and Tennessee. Search, filter by tag or
            year, and sort — pick one to play it and join the conversation.
          </p>
        </header>

        <MediaSearchGallery
          types={VIDEOS}
          scope="MAIN"
          noun="video"
          placeholder="Search videos…"
          emptyLabel="No videos match your search."
          categories={[
            { label: "All", tag: null },
            { label: "Drone", tag: "drone" },
            { label: "Travel", tag: "travel" },
            { label: "Philippines", tag: "philippines" },
            { label: "Indonesia", tag: "indonesia" },
            { label: "Mexico", tag: "mexico" },
            { label: "Thailand", tag: "thailand" },
            { label: "Colombia", tag: "colombia" },
            { label: "Family", tag: "family" },
            { label: "Skiing", tag: "skiing" },
            { label: "Tennessee", tag: "tennessee" },
          ]}
        />
      </div>
    </div>
  );
}
